import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { TrackingDeliveryApi, VENDOR_ENDPOINTS } from '@tracking/const';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrackingDeliveryApiService {
  constructor(private http: HttpClient) {}

  load(trackingId: string): Observable<TrackingDeliveryApi> {
    return this.http.get<TrackingDeliveryApi>(VENDOR_ENDPOINTS.tmsTracking.load, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, 'tmsTrackingLoad'),
      params: new HttpParams().set('shipmentId', trackingId),
    });
  }
}
